import React from "react";
import BoardMemberManagement from "../../features/BoardMemberManagement/BoardMemberManagement";

const BoardMemberManagementPage = () => {
  return (
    <div className="page-container">
      <BoardMemberManagement />
    </div>
  );
};

export default BoardMemberManagementPage;
